<script setup lang="ts">
import PdsCheck from '@/components/pds/PdsCheck.vue';
import { NO_REASON, REFUSAL_REASONS } from '../types';

defineProps<{ disabled?: boolean }>();
const selected = defineModel<string[]>({ required: true });

// « Sans motif » exclut les autres : un motif précis et l'absence de motif se contredisent.
const toggle = (reason: string) => {
  if (selected.value.includes(reason)) {
    selected.value = selected.value.filter((r) => r !== reason);
  } else {
    selected.value =
      reason === NO_REASON
        ? [NO_REASON]
        : [...selected.value.filter((r) => r !== NO_REASON), reason];
  }
};
</script>

<template>
  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
    <button
      v-for="reason in REFUSAL_REASONS"
      :key="reason"
      type="button"
      role="checkbox"
      :aria-checked="selected.includes(reason)"
      :disabled="disabled"
      class="bg-carte flex h-12 cursor-pointer items-center gap-[14px] rounded-[16px] px-[13px] text-left text-[14px] leading-[1.4] disabled:cursor-not-allowed disabled:opacity-60 sm:h-16"
      :class="
        selected.includes(reason)
          ? 'border-encre border-2'
          : 'border-filet border'
      "
      @click="toggle(reason)"
    >
      <PdsCheck :checked="selected.includes(reason)" />
      {{ reason }}
    </button>
  </div>
</template>
